<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <el-form size="small" label-width="100px" class="margin15-tb">
        <p style="font-size: 20px;font-weight:bold">短信平台报警</p><br/>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-row :gutter="24">
              <p style="font-size: 17px;text-align:center;">报警条件</p><br/>
                <label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近&nbsp;&nbsp;
                    <el-input style="width:40%" v-model="msg.msgPlatformAlarmCount"></el-input>&nbsp;&nbsp;条短信
                </label>
                <br/>
                <label>
                    &nbsp;&nbsp;失败率高于&nbsp;&nbsp;<el-input style="width:40%" v-model="msg.msgPlatformFailAlarmRate"></el-input>&nbsp;&nbsp;%
                </label>
                <br/>
                <label>
                  &nbsp;&nbsp;回复率低于&nbsp;&nbsp;<el-input style="width:40%" v-model="msg.msgPlatformResponseAlarmRate"></el-input>&nbsp;&nbsp;%&nbsp;
                  <i class="el-icon-question" title="不含最近5分钟"></i>
                </label>
              </el-row>
          </el-col>
          <el-col :span="9">
            <p style="font-size: 17px;text-align:center;">发送对象</p><br/>
            <el-form-item>
              <div id="msgSendMobiles" v-html="msg.msgPlatformSendMobiles" rows="7" contentEditable="plaintext-only" style="width: 100%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
                </div>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <p style="font-size: 17px;text-align:center;">发送内容</p><br/>
            <el-form-item>
              <div id="msgContent" v-html="msg.msgPlatformSendTemplate" rows="7" contentEditable="plaintext-only" style="width: 100%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <p style="font-size: 20px;font-weight:bold">语音平台报警</p><br/>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-row :gutter="24">
              <p style="font-size: 17px;text-align:center;">报警条件</p><br/>
                <label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近&nbsp;&nbsp;
                    <el-input style="width:40%" v-model="ivr.voiceAlarmCount"></el-input>&nbsp;&nbsp;条短信
                </label>
                <br/>
                <label>
                    &nbsp;&nbsp;失败率高于&nbsp;&nbsp;<el-input style="width:40%" v-model="ivr.voiceFailAlarmRate"></el-input>&nbsp;&nbsp;%
                </label>
              </el-row>
          </el-col>
          <el-col :span="9">
            <p style="font-size: 17px;text-align:center;">发送对象</p><br/>
            <el-form-item>
              <div id="ivrSendMobiles" v-html="ivr.voiceSendMobiles" rows="7" contentEditable="plaintext-only" style="width: 100%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <p style="font-size: 17px;text-align:center;">发送内容</p><br/>
            <el-form-item>
              <div id="ivrContent" v-html="ivr.voiceSendTemplate" rows="7" contentEditable="plaintext-only" style="width: 100%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <p style="font-size: 20px;font-weight:bold">接口报警</p><br/>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-row :gutter="24">
              <p style="font-size: 17px;text-align:center;">报警条件</p><br/>
                <label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;每&nbsp;&nbsp;
                    <el-input style="width:40%" v-model="inter.interfaceAlarmFrequency"></el-input>&nbsp;&nbsp;分钟请求调用
                </label>
              </el-row>
          </el-col>
          <el-col :span="9">
            <p style="font-size: 17px;text-align:center;">发送对象</p><br/>
            <el-form-item>
              <div id="interSendMobiles" v-html="inter.interfaceSendMobiles" rows="7" contentEditable="plaintext-only" style="width: 100%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <p style="font-size: 17px;text-align:center;">发送内容</p><br/>
            <el-form-item>
              <div id="interContent" v-html="inter.interfaceSendTemplate" rows="7" contentEditable="plaintext-only" style="width: 100%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <p style="font-size: 20px;font-weight:bold">标签报警</p><br/>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-row :gutter="24">
              <p style="font-size: 17px;text-align:center;">报警条件</p><br/>
                <label>
                    |标签占比-标签前30日平均占比|>标签前30日占比方差
                </label>
              </el-row>
          </el-col>
          <el-col :span="9">
            <p style="font-size: 17px;text-align:center;">发送对象</p><br/>
            <el-form-item>
              <div id="labelSendMobiles" v-html="label.labelSendMobiles" rows="7" contentEditable="plaintext-only" style="width: 100%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <p style="font-size: 17px;text-align:center;">发送内容</p><br/>
            <el-form-item>
              <div id="labelContent" v-html="label.labelSendTemplate" rows="7" contentEditable="plaintext-only" style="width: 100%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="padding15-tb text right">
          <el-button type="primary" @click="submitSaveAlarmSetting" v-loading.fullscreen.lock="fullscreenLoading" size="small" plain>保存</el-button>
        </div>
    </div>
    <br/>
    <br/>
    <br/>
    <div class="bg-content padding15 m-b-24" style="position: fixed; bottom: 0; width: 100%;">
    发送内容可选参数:<el-button type="text" class="paramter-select" v-for="item in this.alarmParam" :key="item.id" @click="addParamter(item)">{{item.description}}</el-button>&nbsp;

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: {
        msgPlatformId: null,
        msgPlatformAlarmCount: null,
        msgPlatformFailAlarmRate: null,
        msgPlatformResponseAlarmRate: null,
        msgPlatformSendMobiles: null,
        msgPlatformSendTemplate: null
      },
      ivr: {
        voicePlatformId: null,
        voiceAlarmCount: null,
        voiceFailAlarmRate: null,
        voiceSendMobiles: null,
        voiceSendTemplate: null
      },
      inter: {
        interfaceAlarmId: null,
        interfaceAlarmFrequency: null,
        interfaceSendMobiles: null,
        interfaceSendTemplate: null
      },
      label: {
        labelAlarmId: null,
        labelSendMobiles: null,
        labelSendTemplate: null
      },
      alarmParam: null,
      oldContent: null,
      msgAll: null,
      fullscreenLoading: false
    };
  },
  mounted() {
    this.getAlarmSetting();
    this.getTemplateParameter();
  },
  methods: {
    // 获取数据
    getAlarmSetting() {
      this.$ajax({
        url: '/alarm/getAlarmSetting'
      }).then((res) => {
        this.msg.msgPlatformId = res.data.msgPlatform.id;
        this.msg.msgPlatformAlarmCount = res.data.msgPlatform.alarmCount;
        this.msg.msgPlatformFailAlarmRate = res.data.msgPlatform.failAlarmRate;
        this.msg.msgPlatformResponseAlarmRate = res.data.msgPlatform.responseAlarmRate;
        this.msg.msgPlatformSendMobiles = res.data.msgPlatform.sendMobiles;
        this.msg.msgPlatformSendTemplate = res.data.msgPlatform.sendTemplate;

        this.ivr.voicePlatformId = res.data.voicePlatform.id;
        this.ivr.voiceAlarmCount = res.data.voicePlatform.alarmCount;
        this.ivr.voiceFailAlarmRate = res.data.voicePlatform.failAlarmRate;
        this.ivr.voiceSendMobiles = res.data.voicePlatform.sendMobiles;
        this.ivr.voiceSendTemplate = res.data.voicePlatform.sendTemplate;

        this.inter.interfaceAlarmId = res.data.interfaceAlarm.id;
        this.inter.interfaceAlarmFrequency = res.data.interfaceAlarm.alarmFrequency;
        this.inter.interfaceSendMobiles = res.data.interfaceAlarm.sendMobiles;
        this.inter.interfaceSendTemplate = res.data.interfaceAlarm.sendTemplate;

        this.label.labelAlarmId = res.data.labelAlarm.id;
        this.label.labelSendMobiles = res.data.labelAlarm.sendMobiles;
        this.label.labelSendTemplate = res.data.labelAlarm.sendTemplate;
      });
    },
    getTemplateParameter() {
      this.$ajax({
        url: '/template/getFiledAlarmSetting',
        method: 'get'
      }).then((res) => {
        this.alarmParam = res.data.报警内容;
      });
    },
    addParamter(item) {
      let selectId;
      let html;
      // 根据不同的操作定点不同的文本框,在文本框中加入id不同的html
      const idName = window.getSelection().getRangeAt(0).startContainer.parentNode.getAttribute('id');
      if (idName != null) {
        this.oldContent = idName;
      }
      if (this.oldContent === 'msgContent' || this.oldContent === 'msg') {
        // 正在添加模板内容
        selectId = 'msgContent';
        html = '<span id="msg'.concat('" class="parameter" ondblclick="removeCt(', item.id, ')" contentEditable="false"  style="color:red">', item.description, '<font id="', item.id, '" class="paramFont" style="display: none">', item.paramCode, '</font></span>');
      } else if (this.oldContent === 'ivrContent' || this.oldContent === 'ivr') {
        selectId = 'ivrContent';
        html = '<span id="ivr'.concat('" class="parameter" ondblclick="removeCt(', item.id, ')" contentEditable="false"  style="color:red">', item.description, '<font id="', item.id, '" class="paramFont" style="display: none">', item.paramCode, '</font></span>');
      } else if (this.oldContent === 'interContent' || this.oldContent === 'inter') {
        selectId = 'interContent';
        html = '<span id="inter'.concat('" class="parameter" ondblclick="removeCt(', item.id, ')" contentEditable="false"  style="color:red">', item.description, '<font id="', item.id, '" class="paramFont" style="display: none">', item.paramCode, '</font></span>');
      } else if (this.oldContent === 'labelContent' || this.oldContent === 'label') {
        selectId = 'labelContent';
        html = '<span id="label'.concat('" class="parameter" ondblclick="removeCt(', item.id, ')" contentEditable="false"  style="color:red">', item.description, '<font id="', item.id, '" class="paramFont" style="display: none">', item.paramCode, '</font></span>');
      }
      // 把光标放在文本框的最后面
      const node = window.getSelection().anchorNode;
      if (node) {
        if (idName !== selectId) {
          this.keyAction(selectId);
        }
      } else this.keyAction(selectId);
      // 插入html
      this.insertHtmlAtCaret(html);
    },
    keyAction(id) {
      const textbox = document.getElementById(id);
      const sel = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(textbox);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
    },
    // 将内容插入到输入光标所在的位置
    insertHtmlAtCaret(html) {
      let sel;
      let range;
      if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          range = sel.getRangeAt(0);
          range.deleteContents();
          // Range.createContextualFragment() would be useful here but is
          // non-standard and not supported in all browsers (IE9, for one)
          const el = document.createElement('div');
          el.innerHTML = html;
          const frag = document.createDocumentFragment();
          const node = el.firstChild;
          const lastNode = frag.appendChild(node);
          range.insertNode(frag);
          // Preserve the selection
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      } else if (document.selection && document.selection.type !== 'Control') {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
      }
    },
    removeCt(id) {
      $('#p'.concat(id)).remove();
    },
    removeCt2(id) {
      $('#pp'.concat(id)).remove();
    },
    submitSaveAlarmSetting() {
      console.warn('保存');
      const fonts = $('.paramFont');
      for (let i = 0; i < fonts.length; i++) {
        $('#p'.concat($(fonts[i]).attr('id'))).replaceWith($(fonts[i]).html());
      }
      const param = {};
      const msgPlatform = {};
      msgPlatform.id = this.msg.msgPlatformId;
      if (!this.msg.msgPlatformAlarmCount) {
        this.$message({
          message: '短信平台-短信条数不能为空',
          type: 'warning'
        });
        return;
      }
      msgPlatform.alarmCount = this.msg.msgPlatformAlarmCount;
      if (!this.msg.msgPlatformFailAlarmRate) {
        this.$message({
          message: '短信平台-失败率不能为空',
          type: 'warning'
        });
        return;
      }
      msgPlatform.failAlarmRate = this.msg.msgPlatformFailAlarmRate;
      if (!this.msg.msgPlatformResponseAlarmRate) {
        this.$message({
          message: '短信平台-短信回复率不能为空',
          type: 'warning'
        });
        return;
      }
      msgPlatform.responseAlarmRate = this.msg.msgPlatformResponseAlarmRate;
      msgPlatform.sendMobiles = $('#msgSendMobiles').html();
      if (!$('#msgContent').html()) {
        this.$message({
          message: '短信平台-发送内容不能为空',
          type: 'warning'
        });
        return;
      }
      msgPlatform.sendTemplate = $('#msgContent').html();
      // 发送对象
      const msgSendMobileList = this.checkSendMobiles($('#msgSendMobiles').html(), '短信平台');
      if (this.msgAll === '短信平台error') {
        return;
      }
      msgPlatform.sendMobileList = msgSendMobileList;
      param.msgPlatform = msgPlatform;

      const voicePlatform = {};
      voicePlatform.id = this.ivr.voicePlatformId;
      if (!this.ivr.voiceAlarmCount) {
        this.$message({
          message: '语音平台-短息条数不能为空',
          type: 'warning'
        });
        return;
      }
      voicePlatform.alarmCount = this.ivr.voiceAlarmCount;
      if (!this.ivr.voiceFailAlarmRate) {
        this.$message({
          message: '语音平台-失败率不能为空',
          type: 'warning'
        });
        return;
      }
      voicePlatform.failAlarmRate = this.ivr.voiceFailAlarmRate;
      voicePlatform.sendMobiles = $('#ivrSendMobiles').html();
      if (!$('#ivrContent').html()) {
        this.$message({
          message: '语音平台-发送内容不能为空',
          type: 'warning'
        });
        return;
      }
      voicePlatform.sendTemplate = $('#ivrContent').html();
      // 发送对象
      const ivrSendMobileList = this.checkSendMobiles($('#ivrSendMobiles').html(), '语音平台');
      if (this.msgAll === '语音平台error') {
        return;
      }
      voicePlatform.sendMobileList = ivrSendMobileList;
      param.voicePlatform = voicePlatform;

      const interfaceAlarm = {};
      interfaceAlarm.id = this.inter.interfaceAlarmId;
      if (!this.inter.interfaceAlarmFrequency) {
        this.$message({
          message: '接口-扫描频率不能为空',
          type: 'warning'
        });
        return;
      }
      interfaceAlarm.alarmFrequency = this.inter.interfaceAlarmFrequency;
      interfaceAlarm.sendMobiles = $('#interSendMobiles').html();
      if (!$('#interContent').html()) {
        this.$message({
          message: '接口-发送内容不能为空',
          type: 'warning'
        });
        return;
      }
      interfaceAlarm.sendTemplate = $('#interContent').html();
      // 发送对象
      const interSendMobileList = this.checkSendMobiles($('#interSendMobiles').html(), '接口');
      if (this.msgAll === '接口error') {
        return;
      }
      interfaceAlarm.sendMobileList = interSendMobileList;
      param.interfaceAlarm = interfaceAlarm;

      const label = {};
      label.id = this.label.labelAlarmId;
      label.sendMobiles = $('#labelSendMobiles').html();
      if (!$('#labelContent').html()) {
        this.$message({
          message: '标签-发送内容不能为空',
          type: 'warning'
        });
        return;
      }
      label.sendTemplate = $('#labelContent').html();
      // 发送对象
      const labelSendMobileList = this.checkSendMobiles($('#labelSendMobiles').html(), '标签');
      if (this.msgAll === '标签error') {
        return;
      }
      label.sendMobileList = labelSendMobileList;
      param.labelAlarm = label;
      this.fullscreenLoading = true;
      this.$ajax({
        prompt: true,
        url: '/alarm/saveAlarmSetting',
        data: param
      }).then(() => {
        this.msg.msgPlatformSendTemplate = null;
        this.ivr.voiceSendTemplate = null;
        this.inter.interfaceSendTemplate = null;
        this.label.labelSendTemplate = null;
        this.getAlarmSetting();
        this.fullscreenLoading = false;
      });
    },
    // 校验发送对象
    checkSendMobiles(sendMobiles, type) {
      this.msgAll = null;
      if (!sendMobiles) {
        return null;
      }
      if (sendMobiles.length > 500) {
        this.$message({
          message: `${type}-发送对象限制输入500字符`,
          type: 'warning'
        });
      }
      const sendMobileArray = sendMobiles.split(',');
      sendMobileArray.forEach((item) => {
        if (!item) {
          this.$message({
            message: `${type}-手机号不能为空`,
            type: 'warning'
          });
          this.msgAll = `${type}error`;
        } else if (!(/^((13[0-9])|(15[^4n\D])|(18[0-9])|(17[0,6,7,8])|(14[5,7]))\d{8}$/.test(item))) {
          this.$message({
            message: `${type}-手机号填写不正确:${item}`,
            type: 'warning'
          });
          this.msgAll = `${type}error`;
        }
      });
      return sendMobileArray;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/monitor/robotAlarmSetting.vue